import type { ProjectGroupV1Hook } from './types/project.type';
import { type BaseHookResult, createVersionedHook } from './utils/createVersionHooks';
import { useProjectGroupV1 } from './v1';
import { useProjectGroupV2 } from './v2/useProjectGroupV2';

interface UseProjectGroup extends ProjectGroupV1Hook, BaseHookResult {}

export const useProjectGroup = createVersionedHook<UseProjectGroup>(
  {
    v1: useProjectGroupV1,
    v2: useProjectGroupV2,
  },
  'useProjectGroup',
);
